import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { GetDocumentService } from '../../../customServices/get-document.service';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { LanguageService } from '@spartacus/core';


@Component({
  selector: 'app-coreReportsAnnouncementMx',
  templateUrl: './KbCoreReportsAnnouncementMx.component.html',
  styleUrls: ['./KbCoreReportsAnnouncementMx.component.scss'],
  standalone: false
})
export class KbCoreReportsAnnouncementMxComponent {
  documentUrlsMap: { [key: string]: Observable<string> } = {};
  activeLanguage$!: Observable<string>;
  constructor(private documentService: GetDocumentService, private languageService: LanguageService,) { }
  ngOnInit() {
    this.activeLanguage$ = this.languageService.getActive();
    const codes = ['BW8291', 'BW1020ALL', 'Y639946', 'Y458937'];

    codes.forEach(code => {
      this.documentUrlsMap[code] =
        this.documentService.getDocumentByDocumentCode(code).pipe(map((res: any) => res?.url ?? ''),
          shareReplay(1)
        );

    });

    // this.loadDocument('BW8291');
    // this.loadDocument('CBDOCS3');
    // this.loadDocument('Y639946');
    // this.loadDocument('Y458937');

  }
  loadDocument(code: string) {
    if (this.documentUrlsMap[code]) {
      this.documentUrlsMap[code] =
        this.documentService.getDocumentByDocumentCode(code).pipe(
          map((res: any) => res?.url ?? ''),
          shareReplay(1)
        );

    }
  }
}
